// «Zobacz w środku»: ONLY real pages from POLSKI GOTOWY™ Tom 1 (Gamma Estudio, pages 10, 11, 18, 27, 34). Empty = section hidden.
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/a82e8feb-a29c-4b24-a1c6-ab5c07e6ea32/';
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [{
  src: BASE + '1792782542761_polski-gotowy-tom1-p10-lekcja-ecc29610.webp',
  label: 'Lekcja minuta po minucie',
  title: 'Mit o Prometeuszu – strona nauczyciela',
  text: 'Cel, materiały i przebieg 45 minut (0–5, 5–15, 15–35, 35–42, 42–45) z instrukcją i kluczem odpowiedzi.'
}, {
  src: BASE + '1792782547425_polski-gotowy-tom1-p11-karta-a61ba593.webp',
  label: 'Karta pracy w 3 poziomach',
  title: 'Mit o Prometeuszu – karta ucznia',
  text: 'Poziom 1, 2 i 3 na jednej kartce, do druku, z samooceną ucznia: łatwe · w sam raz · trudne.'
}, {
  src: BASE + '1792782551994_polski-gotowy-tom1-p18-lektura-03b195a0.webp',
  label: 'Karta do lektury',
  title: 'Chłopcy z Placu Broni – honor i przyjaźń',
  text: 'Gotowa lekcja do lektury w klasie 5: rozmowa, praca z tekstem, mapa myśli i klucz odpowiedzi.'
}, {
  src: BASE + '1792782556190_polski-gotowy-tom1-p27-gramatyka-b855296c.webp',
  label: 'Ćwiczenia z gramatyki',
  title: 'Zdanie pojedyncze i złożone',
  text: 'Trzy poziomy ćwiczeń: rozpoznawanie zdań, przecinki i łączenie zdań spójnikami.'
}, {
  src: BASE + '1792782560069_polski-gotowy-tom1-p34-sprawdzian-add12c0c.webp',
  label: 'Sprawdzian z kluczem',
  title: 'Sprawdzian po 12 lekcjach',
  text: '8 zadań, 20 punktów, 45 minut – gotowy do wydruku, z kluczem, punktacją i skalą ocen dla nauczyciela.'
}];
